import {styled} from '@mui/material'



const EmailTemplateView = () => {

    return(
      <EmailTemplateViewContainer>
        <div className='header'>
          <div>
            <span className='left'>code</span>
            <span className='right'>534</span>
          </div>
          <div>
            <span className='left'>Name</span>
            <span className='right'>Traninig Induction</span>
          </div>
          <div>
            <span className='left'>Membership Route</span>
            <span className='right'>Examination</span>
          </div>
        </div>
        < div className='title'>
          <div>Title / Subject</div>
          < div className='titleContent'>
             Invitation to Training
          </div>
        </div>
        < div className='title'>
          <div>Message</div>
          < div className='titleContent'>
          Congratulations!!!  <br/>
          After careful evaluation of your application process. We are pleased to inform you that you are eligible to move the next application process. You are invited to the training session.
          <br/>
          <br/>
          <br/>
          Best Ragards.
          </div>
        </div>
      </EmailTemplateViewContainer>
    )
  }

  export default EmailTemplateView;
  
  const EmailTemplateViewContainer = styled('div')`

    & .header{
      padding: 40px;
      display: flex;
      flex-direction: column;
      gap : 24px;
  
      & > div{
        display: flex;
        justify-content: space-between;
      }
  
      & .right{
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        color: #020D08;
      }
  
      & .left{
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        color: #4E5A62;
      }
    }
  
    & .title {
      
      & div {
        background: #F1F5F2;
        font-weight: 500;
        font-size: 24px;
        padding-inline: 40px;
        padding-block: 4px;
        line-height: 28px;
      }
  
      & > .titleContent{
        padding-block: 30px;
        background: #FFFFFF;
        font-weight: 400;
        font-size: 24px;
        line-height: 37px;
        color: #020D08;
      }
    }
  
    & .message{
  
    }
  
  `